import React, { useState } from 'react'
import { toast } from 'react-toastify'
import api from '../../services/api'
import './CadastrarMotorista.css'

const CadastrarMotoristaModal = ({
  isOpen,
  onClose,
  onSuccess,
  refreshList
}) => {
  const [loading, setLoading] = useState(false)
  const [unitId, setUnitId] = useState('b2782350-0655-11f0-b6fa-9f7aebdea2ec')
  const [formData, setFormData] = useState({
    name: '',
    cpf: '',
    phone: ''
  })

  const handleChange = e => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleSubmit = async e => {
    e.preventDefault()
    setLoading(true)

    try {
      const token = localStorage.getItem('token')
      const user_name = localStorage.getItem('name')

      if (!token || !user_name) {
        toast.error('Sessão expirada. Faça login novamente.')
        return
      }

      if (!formData.name || !formData.cpf || !formData.phone) {
        toast.error('Preencha todos os campos obrigatórios')
        return
      }

      await api.post(`/api/driver/unit/${unitId}/${user_name}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })

      toast.success('Motorista cadastrado com sucesso!')
      // Limpa o formulário
      setFormData({
        name: '',
        cpf: '',
        phone: ''
      })
      refreshList() // Chama a função para atualizar a lista
      onClose()
    } catch (error) {
      console.error('Erro ao cadastrar motorista:', error)
      toast.error(
        error.response?.data?.message || 'Erro ao cadastrar motorista'
      )
    } finally {
      setLoading(false)
    }
  }

  if (!isOpen) return null

  return (
    <div className='modal-overlay'>
      <div className='modal-content'>
        <div className='modal-header'>
          <h3>Cadastrar Novo Motorista</h3>
          <button onClick={onClose} className='modal-close-button'>
            &times;
          </button>
        </div>

        <form onSubmit={handleSubmit} className='driver-form'>
          <div className='form-group'>
            <label htmlFor='unitId'>Unidade:</label>
            <select
              id='unitId'
              value={unitId}
              onChange={e => setUnitId(e.target.value)}
              className='form-control'
            >
              <option value='b2782350-0655-11f0-b6fa-9f7aebdea2ec'>
                Unidade 01 (Av. Brasil, 6624)
              </option>
              <option value='813c4ab0-065e-11f0-a3b6-4dae11bd9299'>
                Unidade 02 (Av. Brasil, 1590)
              </option>
            </select>
          </div>

          <div className='form-group'>
            <label htmlFor='name'>Nome completo*</label>
            <input
              type='text'
              id='name'
              name='name'
              value={formData.name}
              onChange={handleChange}
              className='form-control'
              required
            />
          </div>

          <div className='form-group'>
            <label htmlFor='cpf'>CPF*</label>
            <input
              type='text'
              id='cpf'
              name='cpf'
              value={formData.cpf}
              onChange={handleChange}
              className='form-control'
              required
            />
          </div>

          <div className='form-group'>
            <label htmlFor='phone'>Telefone*</label>
            <input
              type='text'
              id='phone'
              name='phone'
              value={formData.phone}
              onChange={handleChange}
              className='form-control'
              required
            />
          </div>

          <div className='form-actions'>
            <button type='button' onClick={onClose} className='cancel-button'>
              Cancelar
            </button>
            <button type='submit' disabled={loading} className='submit-button'>
              {loading ? 'Cadastrando...' : 'Cadastrar Motorista'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

const CadastrarMotorista = ({ refreshDrivers }) => {
  const [modalOpen, setModalOpen] = useState(false)

  return (
    <div>
      <div className='listar-motoristas-container'>
        <div className='container-drivers'>
          <div
            className='header-section'
            style={{ justifyContent: 'space-between' }}
          >
            <h2>Motoristas</h2>
            <button
              onClick={() => setModalOpen(true)}
              className='open-modal-button'
            >
              + Cadastrar Novo Motorista
            </button>
          </div>
        </div>
      </div>

      <CadastrarMotoristaModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        refreshList={refreshDrivers} // Passa a função de atualização
      />
    </div>
  )
}

export default CadastrarMotorista
